import VModal from '@/vuetify_custom/v-modal_v1'
import VTable, { type_name } from '@/vuetify_custom/v-table/v1'
import styles from './index.module.less'
const title_hash = {
  5: '填写',
  6: '审核'
}
const next_status = {
  opening: 'auditing',
  auditing: 'paying'
}
const tableFields = [
  {
    text: '申请人',
    align: 'center',
    value: 'account',
    width: 100,
  },
  {
    text: '团队',
    align: 'center',
    value: 'team',
  },
]
export default {
  data() {
    return {
      dis:false,
      title: '',
      type: '',
      next_topic_status: '',
      topic: {},
      arr: [],
      loading: false
    }
  },
  computed: {
    tableFieldsSj() {
      if(this.topic&&this.topic.status==='opening') {
        return tableFields.concat({
          text: '申请条目',
          align: 'center',
          value: 'interns_count',
        })
      }
      return tableFields
    }
  },
  methods: {
    show(status,topic) {
      this.arr = []
      this.dis = true
      this.type = status
      this.next_topic_status = next_status[topic.status]
      this.topic = topic
      this.getData()
    },
    getData() {
      this.loading = true
      this.$http.get(Util.api.informal_wage_topic_update_status_confirm, {
        id:this.topic.id,
        status: this.next_topic_status
      }).then((data) => {
        this.arr = data.notified_customer
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      // update_informal_wage_topic_status
      this.saving = true
      this.$http.post(Util.api.update_informal_wage_topic_status, {
        id:this.topic.id,
        status: this.next_topic_status
      }).then((data) => {
        // this.$Message.success('')
        this.dis = false
       this.$emit('success')
      }).finally(() => {
        this.saving = false
      })
    }
  },
  render() {
    const _this = this
    const type = this.type
    return <VModal 
      dynamicHeight
      heightRate={0.9}
      v-model={this.dis}
      title="提示"
      loading={this.saving}
      width={800}
      ref="modal"
      okText="是"
      cancelText="否"
      on={{
        ok: _this.submit
      }}
    >
      <div class={styles['flex-contain']}>
        <div style="flex:1;overflow:auto">
          <VTable 
            headers={_this.tableFieldsSj}
            desserts={_this.arr}
            loading={_this.loading}
          />
        </div>
        <p style={{
          margin: '10px 0',
          'textAlign': 'right'
        }}>关闭流程后，系统将推送
          {title_hash[type]}
          关闭通知给各审核人，请确认是否关闭
          {title_hash[type]}
          通道？
        </p>
      </div>
  </VModal>
  }
}